import bigTagButtonStyles from "./BigTagButton.css.js";

const BigTagButton = ({ active, onClick, children }) => {
  return (
    <button
      type="button"
      className={bigTagButtonStyles.BigTagButton({ active: active })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default BigTagButton;
